module.exports = __webpack_public_path__ + "static/media/02-menu.37cb444e.png";